const domains = {
  id: "domains",
  label: "Domains",
  endpoint: "domains",
  columnConfig: [
    {
      field: "name",
      headerName: "Domain",
      width: 250,
      description: "Domain",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default domains;
